<ion-card>
  <div class="stack">
    <div class="type details-container">
      <lib-subscription-type [type]="type$$()"></lib-subscription-type>
    </div>

    @if (!isPrepaid$$()) {
    <div class="subscription details-container">
      <div class="valuepair">
        <div class="label">{{ 'menu.subscriptionCard.photos' | transloco }}</div>
        <div class="value" [class.low]="isLowImageCredits$$()">{{ unlimitedImageCredits$$() ? ('menu.subscriptionCard.unlimited' | transloco) : imageCredits$$() }}</div>
      </div>
      <div class="valuepair">
        <div class="label">{{ 'menu.subscriptionCard.videos' | transloco }}</div>
        <div class="value" [class.low]="isLowVideoCredits$$()">{{ videoCredits$$() }}</div>
      </div>
      <div class="pie-container">
        <lib-subscription-slot-usage class="pie" [total]="cameraSlots$$()" [used]="assignedCamerasCount$$()"></lib-subscription-slot-usage>
        <ion-label class="pie-title label">{{ 'menu.subscriptionCard.cameraSlots' | transloco }}</ion-label>
      </div>
    </div>
    }
  </div>

  <div class="prepaid-container">
    <div class="valuepair">
      <div class="label">{{ 'menu.subscriptionCard.prepaidCredits' | transloco }}</div>
      <div class="value" [class.low]="isLowPrepaidCredits$$()">{{ prepaidCredits$$() }}</div>
    </div>

    <ion-button fill="clear" expand="block" size="small" (click)="handleAddCredits()" class="subscription-link">
      <ion-label class="label">{{ 'menu.subscriptionCard.addCredits' | transloco }}</ion-label>
      <ion-icon name="open-externally" slot="end" class="link-icon"></ion-icon>
    </ion-button>
  </div>

  @if (isLowPrepaidCredits$$() || isEmptyPrepaidCredits$$()) {
  <div class="warning-container">
    <ion-icon name="info"></ion-icon>
    <ion-label> {{ (`menu.subscriptionCard.${isPrepaid$$() ? 'prepaid' : 'subscribed'}.${isEmptyPrepaidCredits$$() ? 'emptyCredits' : 'lowCredits'}`) | transloco }} </ion-label>
  </div>
  }

  <div class="cta-container">
    <lib-app-button data-testid="manage-plan-and-credits-button" expand="block" color="primary" (click)="handleManagePlanAndCredits()"
      >{{ 'menu.subscriptionCard.' + (isPrepaid$$() ? 'prepaid' : 'subscribed') + '.storeButton' | transloco }}</lib-app-button
    >
  </div>
</ion-card>
